/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import hero1 from '../../images/slider/3.png'
import { useLanguage } from '../../i18n/LanguageContext';


const ClickHandler = () => {
    window.scrollTo(10, 0);
}


const Hero3 = () => {
    const { language, t } = useLanguage();
    const dishes = t('cooking.dishes');
    const [dishIndex, setDishIndex] = useState(0);

    useEffect(() => {
        setDishIndex(0);
        const timer = window.setInterval(() => {
            setDishIndex((currentIndex) => (currentIndex + 1) % dishes.length);
        }, 3000);

        return () => window.clearInterval(timer);
    }, [language, dishes.length]);

    return (
        <section className="static-hero-s3">
            <div className="hero-container">
                <div className="hero-inner">
                    <div className="container-fluid">
                        <div className="hero-content">
                            <div data-swiper-parallax="300" className="slide-title">
                                <h2>{t('cooking.title')}
                                <p>{t('cooking.together')}</p>
                                    <span>
                                        <small>{dishes[dishIndex]}</small>
                                        <i className="s1"></i>
                                        <i className="s2"></i>
                                        <i className="s3"></i>
                                        <i className="s4"></i>
                                    </span>
                                </h2>
                            </div>
                            <div data-swiper-parallax="400" className="slide-text">
                                <p>{t('cooking.description')}</p>
                            </div>
                            <div className="clearfix"></div>
                            <div data-swiper-parallax="500" className="slide-btns">
                                {/* <Link onClick={ClickHandler} to="/about" className="theme-btn">Get Started</Link> */}
                            </div>
                            <div className="student-pic">
                                <img src={hero1} alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero3;
